import { render, staticRenderFns } from "./Project9.vue?vue&type=template&id=6b31b4a0&scoped=true&"
import script from "./Project9.vue?vue&type=script&lang=js&"
export * from "./Project9.vue?vue&type=script&lang=js&"
import style0 from "./Project9.vue?vue&type=style&index=0&id=6b31b4a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b31b4a0",
  null
  
)

export default component.exports